<!--  测试付款 -->
<template>
  <div v-if="bodyShow">
    <!-- <div class="title-box">
        <span class="cancel">取消</span>
        <span class="title">支付</span>
    </div> -->
    <!--  -->
    <div class="main" v-if="bodyShow">
        <h4>{{data.name}}</h4>
        <h4 class="on">￥0.01</h4>
        <div class="small">
            <span>收款方</span>
            {{data.principal_name}}
        </div>
        <a href="javascript:;" class="subBtn" @click="pay()">立即支付</a>
    </div>
  </div>
</template>

<script>
import { testpay, testpayinfo } from "@/api/other";
import { goAuthLogin } from '@/utils/tools'
export default {
    data(){
        return{
            data:{},
            bodyShow:false,
            pay_config_id: ''
        }
    },
    methods:{
      pullData() {
        testpayinfo({
            pay_config_id: this.pay_config_id
        }).then(data => {
            if (data.code == 10002) {
                this.$toast(data.data.msg);
                return false;
            }
            if(!data.openid) {
                return goAuthLogin('绑定第三方OPENID', data.app_id);
            }

            this.data = data;
            document.title = "测试支付";
            this.bodyShow = true;
        });
      },
      pay() {
        testpay({
          pay_config_id: this.pay_config_id
        }).then(data => {
            if (data.code == 10002) {
                this.$toast(data.data.msg);
                return false;
            }
            let data_ = eval("(" + data.jsApiParameters + ")");
            let jsApiCall = () => {
                WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                    WeixinJSBridge.log(rest.err_msg);
                    if (rest.err_msg == "get_brand_wcpay_request:ok") {
                        this.$toast('支付成功');
                    } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                        alert("支付取消");
                    } else {
                        alert("支付失败");
                    }
                });
            };

            if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
            } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
            }
            } else {
                jsApiCall();
            }
        });
      }
    },
    created(){
      this.pay_config_id = this.$route.query.pay_config_id;
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.title-box{
    height: 90px;
    line-height: 90px;
    background-color: #e0e0e0;
    color: #333333;
    text-align: center;
    font-size: 30px;
    position: relative;
    span.cancel{
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
    }
    .title{
        margin:auto;
    }
}
.main{
    background-color:#ffffff;
    text-align:center;
    color:#333333;
    padding-top:50px;
    padding-bottom:50px;
    position: absolute;
    height: 100%;
    width: 100%;
    h4{
        font-size:24px;
        margin-bottom:20px;
        font-weight:bold;
    }
    h4.on{
        margin-bottom:90px;
        font-size:48px;
    }
    .small{
        font-size:26px;
        display:flex;
        padding: 20px;
        border-top:1px solid #dddddd;
        border-bottom:1px solid #dddddd;
        span{
            margin-right:auto;
            align-items: center;
        }
    }
}
.subBtn{
    background-color:#00C25F;
    color:#f0f0f0;
    width:700px;
    text-align:center;
    display:block;
    margin:80px auto 0;
    line-height:80px;
    font-size:28px;
    border-radius:8px;
}
</style>